import React from "react";
import {
  FiSearch,
  FiArrowRight,
  FiGlobe,
  FiUser,
  FiCpu,
  FiActivity,
} from "react-icons/fi";
import "./AI.css";

interface SuggestedTopic {
  icon: string; // string key for dynamic icons
  label: string;
  link?: string;
}

interface AIProps {
  id?: string;
  title: string;
  description: string;
  searchPlaceholder?: string;
  suggestions: SuggestedTopic[];
}

// Dynamic icon map using 'any' for flexibility (same as FeatureGrid)
const iconMap: Record<string, any> = {
  FiSearch: FiSearch,
  FiArrowRight: FiArrowRight,
  FiGlobe: FiGlobe,
  FiUser: FiUser,
  FiCpu: FiCpu,
  FiActivity: FiActivity,
};

// Function to render icon dynamically (same as FeatureGrid)
const getIcon = (name: string): React.ReactNode | null => {
  const IconComponent = iconMap[name];
  if (!IconComponent) {
    console.warn(`Unknown icon: ${name}`);
    return null;
  }
  return React.createElement(IconComponent, { className: "ai-suggestion-icon" });
};

export const AI: React.FC<AIProps> = ({
  id,
  title,
  description,
  searchPlaceholder = "Explore our research...",
  suggestions,
}) => {
  return (
    <section id={id} className="ai-section">
      <div className="ai-content">
        <div className="ai-left">
          <h2 className="ai-title">{title}</h2>
          <p className="ai-description">{description}</p>

          <div className="ai-search-bar">
            <div className="ai-search-icon">{getIcon("FiSearch")}</div>
            <input type="text" placeholder={searchPlaceholder} />
            <button className="ai-search-submit">{getIcon("FiArrowRight")}</button>
          </div>
        </div>

        <div className="ai-right">
          <h3 className="ai-subtitle">Suggested Focus Areas</h3>
          <div className="ai-suggestions">
            {suggestions.map((topic, i) => (
              <div key={i} className="ai-suggestion-item">
                <div className="ai-suggestion-wrapper">
                  <div className="ai-suggestion-icon-wrapper">
                    {getIcon(topic.icon) || getIcon("FiSearch")}
                  </div>
                  <span>{topic.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AI;
